function ReportsControls() {
    "use strict";

    this.ReportInstance = null;
    this.CardView = null;
    this.CardViewTimer = null;
    this.CardViewFilter = null;
    this.CardViewPaginator = null;
    this.ReportInstanceFiltersListView = null;
    this.Validator = null;
    this.OrganizationTreeControl = null;
    this.SchedulesListView = null;
    this.SchedulesCardView = null;
    this.SchedulesValidator = null;
    this.SchedulesCardViewFilter = null;
    this.ScheduleFilterListView = null;
    this.ScheduleEmailListView = null;
    this.ScheduleEmailValidator = null;
    this.ScheduleFilterValidator = null;
}
if (typeof exports !== 'undefined') {
    module.exports = ReportsControls;
}